module.exports = __webpack_public_path__ + "static/media/screenPreview.c430f99c.png";